import { api } from '@/constants'
import { getAuthHeader, serializeQueryParams } from '@/util'
import baseURL from '@/service/api'

const admin = {
  adminList: params => {
    const url = api.admin.list + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  adminDetail: id => {
    const url = api.admin.detail(id)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  createAdmin: payloads => {
    const url = api.admin.list
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  }
}
export default admin
